import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'ebebek',
  logo: { name: 'ebebek', src: '/logo/ebebekcard.png' },
  portrait: { src: '/photo/portrait-baris-simsek.png', alt: 'Barış Şimşek' },
  quote: [
    'We are among the fortunate executives who know our digital maturity score. This score '
    + 'serves as a guiding light in our digital transformation journey.',
    'It allows us to clearly see where we were in the past, where we stand today, and where '
    + 'we need to go in the future by comparing ourselves with industry and global '
    + 'benchmarks.',
    'We chose Digitopia’s DMI methodology because it provides valuable insights and industry '
    + 'comparisons by analyzing us across six key dimensions. It does not just focus on IT; it '
    + 'also covers technology, governance, people, and processes.',
    'With periodic evaluations, we can ensure we are on the right track and take the '
    + 'necessary actions accordingly.',
  ],
  attribution: 'Barış Şimşek, CTO',
  story: 'ebebek',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 4
